var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsertComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2174 10.4348H10.4348V15.2174C10.4348 15.4574 10.24 15.6522 10 15.6522C9.76 15.6522 9.56522 15.4574 9.56522 15.2174V10.4348H4.78261C4.54261 10.4348 4.34783 10.24 4.34783 10C4.34783 9.76 4.54261 9.56522 4.78261 9.56522H9.56522V4.78261C9.56522 4.54261 9.76 4.34783 10 4.34783C10.24 4.34783 10.4348 4.54261 10.4348 4.78261V9.56522H15.2174C15.4574 9.56522 15.6522 9.76 15.6522 10C15.6522 10.24 15.4574 10.4348 15.2174 10.4348M10 0C4.47652 0 0 4.47652 0 10C0 15.5235 4.47652 20 10 20C15.5235 20 20 15.5235 20 10C20 4.47652 15.5235 0 10 0",
    fill: "#CCCCCC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsertComponent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Insert_component.0cc0132c5aa619a6b9e7b64cb18f370b.svg";